'use client';

import { StatusType, datadogLogs } from '@datadog/browser-logs';
import {LOG_INTERVAL, Logger} from './logging-types';
import { sLog } from './server-logging';

let logger: Logger;
const loggedMessages = new Map<string, number>();

export function cLog() {
    if (!logger && isClient()) {
        logger = initLogger();
    }
    return logger ?? (isClient() ? console : sLog());
}

function initLogger() {
    const jsonLogger = datadogLogs.createLogger('client', {
        level: (process.env.NEXT_PUBLIC_LOG_LEVEL as StatusType) ?? StatusType.info,
    });

    const clientLogger: Logger = {
        debug: deduplicateLog('debug'),
        info: deduplicateLog('info'),
        warn: deduplicateLog('warn'),
        error: deduplicateLog('error'),
    };

    function deduplicateLog(level: keyof Logger) {
        return (msg: string | Object, obj?: Record<string, unknown>) => {
            const key = `${level}:${msg}`;
            const now = Date.now();

            const lastLogged = loggedMessages.get(key);

            if (!lastLogged || now - lastLogged > LOG_INTERVAL) {
                loggedMessages.set(key, now);
                logFn(level, msg.toString(), obj);
            }
        };
    }

    function logFn(method: keyof Logger, msg: string, obj?: Record<string, unknown>) {
        const { error, ...rest } = (obj ?? {}) as { error?: Error };
        jsonLogger[method](msg, rest, error as Error | undefined);
    }

    return clientLogger;
}

function isClient() {
    return typeof window !== 'undefined';
}
